<template>
  <h1 class="loading">loading...</h1>
</template>
<script>
export default {
  name: 'AuthLoading',
  components: {},
  props: {},
  emits: [],
  setup() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.loading {
  text-align: center;
}
</style>
